import React, { Component } from "react";
import {
  Paper,
  Grid,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  withStyles,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Table,
  Typography,
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./style";
import classNames from "classnames";
import Loading from "../loading";
import Snackbar from "../snackbar";
import Header from "../../partials/header";
import LabelForm from "../../partials/labelForm";
import EnhancedTableHead from "../../partials/TableFormat/head";
import { Link } from "react-router-dom";
import {
  formatDatetime,
  OwnerRole,
  EmployeeRole,
  moduleToGroup,
  Role,
} from "../../utils/setting";
import { Cookies } from "react-cookie";
const cookie = new Cookies();
const headCells = [
  {
    key: "serviceName",
    numeric: false,
    disablePadding: false,
    label: "module_service_name",
  },
  {
    key: "expiredDay",
    numeric: false,
    disablePadding: false,
    label: "module_expire_day",
  },
  {
    key: "status",
    numeric: false,
    disablePadding: false,
    label: "module_status",
  },
  { key: "action", numeric: false, disablePadding: false, label: "" },
];
class ModulePackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupModule: {},
      package: {},
      packageName: "",
      packageCode: "",
      packageList: [],
      packageTitle: "Package Free",
      expiredDays: "",
      role: "",
    };
  }
  componentDidMount() {
    this.findServiceRoleForSpa();
    this.getListPackage();
    this.props.getServiceAccount();
  }
  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.moduleRole).length !== 0 &&
      cookie.get(Role) === EmployeeRole
    ) {
      this.groupModule(nextProps.moduleRole);
      this.setState({
        role: EmployeeRole,
      });
    }
    // if(nextProps.moduleRole)
  }
  groupModule = (packages) => {
    let json = moduleToGroup(packages);
    this.setState({
      groupModule: json,
    });
  };
  findModuleRoleForEmployee = async () => {
    this.loading.startLoading();
    let check = await this.props.findModuleRoleForEmployee();
    this.loading.stopLoading();
    if (check.code === 1 && check.data) {
      this.groupModule(check.data);
      this.setState({
        role: EmployeeRole,
      });
    }
  };
  findServiceRoleForSpa = async () => {
    let { role } = this.props;
    this.loading.startLoading();
    let check = await this.props.findServiceRoleForSpa();
    this.loading.stopLoading();
    if (check.code === 1 && check.data) {
      if (role !== EmployeeRole) {
        this.groupModule(check.data.moduleRole);
      }
      this.setState({
        packageCode: check.data.package,
        expired: check.data.expired,
        serviceName: check.data.serviceName,
      });
    }
  };
  handleChange = (name, action) => (event) => {
    let { t } = this.props;
    this.mSnackbar.handleClick(t("contact_admin_to_change"), "warning");
    // let keyPackage =  Object.keys(this.state.package);
    // let valuePackage = Object.values(this.state.package);
    // let packages = this.state.package
    // keyPackage.map((key, index)=>{
    //     switch (key) {
    //         case name:
    //         {
    //             packages[name][action] =  event.target.checked ? 1 : 0
    //             break;
    //         }
    //     }
    // })
    // this.setState({package: packages})
    // this.groupModule(packages)
  };
  getListPackage = async () => {
    let check = await this.props.getListPackage();
    if (check.code === 1) {
      this.setState({
        packageList: check.data,
      });
    }
  };
  change = () => {
    let { t } = this.props;
    this.mSnackbar.handleClick(t("contact_admin_to_change"), "warning");
  };
  formatExpiredDay = (expiredDay) => {
    let expired =
      expiredDay > 0
        ? Math.round((expiredDay - new Date().getTime()) / 1000 / 60 / 60 / 24)
        : 0;
    return expired;
  };
  renderActionCustom = () => {
    const { classes, t, serviceAccount } = this.props;
    let balance =
      serviceAccount && serviceAccount.balance ? serviceAccount.balance : 0;
    return (
      <div className={classes.containerButton}>
        <NumberFormat
          value={balance}
          thousandSeparator
          displayType="text"
          renderText={(value) => (
            <Typography>
              {t("service_account_balance")}: {value}
            </Typography>
          )}
        />
      </div>
    );
  };

  changeCapitalize = (string) => {
    if (typeof string !== "string") return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  render() {
    const { classes, t, service, role } = this.props;
    const { groupModule = {} } = this.state;
    let keysGroupModule = Object.keys(groupModule);
    let valuesGroupModule = Object.values(groupModule);
    let packageName = this.state.packageList.find(
      (ele) => ele.packageCode === this.state.packageCode
    );
    packageName = packageName ? packageName.packageName : "Basic";
    let packageTitle =
      t("module_you_using_package") +
      " " +
      this.changeCapitalize(packageName) +
      " (";
    let checkExpired = false;
    if (this.state.expired && this.state.expired - new Date().getTime() <= 0)
      checkExpired = true;
    packageTitle +=
      this.state.expired === 0
        ? t("module_package_free")
        : t("module_package_will_expired_in");
    const fullName = this.props.userState.lastName.concat(
      " ",
      this.props.userState.firstName
    );
    let titleModule = `${t("module_using_package")} ${fullName}`;
    return (
      <React.Fragment>
        <Header
          session={t("sidebar_manage")}
          title={t("extend")}
          renderActionCustom={this.renderActionCustom}
        />

        <Paper>
          <div className={classes.tableWrapper}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
            >
              <EnhancedTableHead
                classes={classes}
                headCells={headCells}
                showCheckBox={false}
              />
              <TableBody>
                <TableRow>
                  <TableCell
                    className={classes.customCell}
                    component="th"
                    scope="row"
                  >
                    {service.name}
                  </TableCell>
                  <TableCell className={classes.customCell} align="left">
                    {this.state.expired !== 0
                      ? formatDatetime(this.state.expired)
                      : t("service_admin_listservice_unLimit")}
                  </TableCell>
                  <TableCell className={classes.customCell} align="left">
                    {this.formatExpiredDay(this.state.expired) > 0 ||
                    this.state.expired === 0
                      ? t("module_status_is_using")
                      : t("module_status_expired")}
                  </TableCell>
                  {role !== EmployeeRole && (
                    <TableCell className={classes.customCell} align="left">
                      <Link to="/module/extend">
                        <Button size="small" variant="outlined" color="primary">
                          {" "}
                          {t("extend")}{" "}
                        </Button>
                      </Link>
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Paper>
        <div className={classes.space}></div>
        <LabelForm label={titleModule} />
        <Paper className={this.props.role === EmployeeRole && classes.paper}>
          {this.props.role === OwnerRole ? (
            <div className={classes.topBar}>
              <div
                className={classNames(
                  classes.packageName,
                  classes["packageName_" + packageName]
                )}
              >
                {packageName}
              </div>
              <div
                className={classNames(
                  classes.arrowPackage,
                  classes["arrowPackage_" + packageName]
                )}
              ></div>
              <div className={classes.notification}>
                {checkExpired ? t("module_package_expired") : packageTitle}
              </div>
              {this.state.expired && !checkExpired ? (
                <div className={classes.expiredDays}>
                  {this.formatExpiredDay(this.state.expired) +
                    " " +
                    t("module_package_days") +
                    ")."}
                </div>
              ) : checkExpired ? (
                ""
              ) : (
                ")."
              )}
              {/* <a onClick={this.change}>{t('module_contact_your_admin_if_you_need_to_update_your_package')}</a> */}
            </div>
          ) : (
            ""
          )}
          <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
          <Loading onRef={(id) => (this.loading = id)} />
          <Grid container spacing={3} className={classes.root}>
            {keysGroupModule.map((keyGroup, i) => {
              let valuesOfKeyGroup = Object.keys(valuesGroupModule[i]);
              return valuesOfKeyGroup.map((a, j) => {
                let valuesKeysGroup = Object.values(valuesGroupModule[i]);
                let keysOfValuesKeyGroup = Object.keys(valuesKeysGroup[j]);
                let find_package = keysOfValuesKeyGroup.find(
                  (e) => e === "package"
                );
                if (find_package)
                  find_package = valuesKeysGroup[j][find_package];

                return (
                  <Grid item xs={4} sm={3} md={2} key={j}>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      {j === 0 ? (
                        <FormLabel component="legend" className={classes.title}>
                          {t("module_" + keyGroup)}
                        </FormLabel>
                      ) : (
                        <FormLabel component="legend" className={classes.title}>
                          {t()}
                        </FormLabel>
                      )}

                      <FormLabel
                        component="legend"
                        className={classes.formLabel}
                      >
                        {t("module_" + a)}{" "}
                        {find_package ? (
                          <img
                            class="package-icon"
                            src={`/images/${find_package}-medal.svg`}
                            alt="package icon"
                          />
                        ) : (
                          ""
                        )}
                      </FormLabel>

                      {keysOfValuesKeyGroup.map((b, k) => {
                        return b !== "limit" && b !== "package" ? (
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    Object.values(valuesKeysGroup[j])[k] === 1
                                      ? true
                                      : false
                                  }
                                  onChange={this.handleChange(a, b)}
                                  value={b}
                                />
                              }
                              className={classes.label}
                              label={t("module_action_" + b)}
                            />
                          </FormGroup>
                        ) : (
                          ""
                        );
                      })}
                    </FormControl>
                  </Grid>
                );
              });
            })}
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

const mapState = (state) => ({
  moduleRole: state.user && state.user.module,
  role:
    state.user &&
    state.user.user &&
    state.user.user.roleId &&
    state.user.user.roleId.role
      ? state.user.user.roleId.role
      : null,
  service: state.service.service,
  serviceAccount: state.serviceAccount.serviceAccount,
  userState: state.user ? state.user.user : {},
});

const mapDispatch = (dispatch) => ({
  findServiceRoleForSpa: dispatch.serviceRole.findServiceRoleForSpa,
  getListPackage: dispatch.packages.getListPackage,
  getServiceAccount: dispatch.serviceAccount.getServiceAccount,
  findModuleRoleForEmployee: dispatch.employees.findModuleRoleForEmployee,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(styles, { withTheme: 0 })(ModulePackage))
);
